var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "addresses-list" },
    [
      _c(
        "ScrolledTable",
        {
          staticClass: "lg",
          attrs: { "fix-last": true },
          on: { nextPage: _vm.nextPage },
        },
        [
          _c("table", { staticClass: "h-table" }, [
            _c("thead", [
              _c(
                "tr",
                [
                  _vm._l(_vm.columns, function (column) {
                    return _c(
                      "th",
                      {
                        key: column.id,
                        style: {
                          width: _vm.getColumnWidth(column),
                          minWidth: _vm.getColumnWidth(column),
                        },
                      },
                      [
                        _c("TableHeader", {
                          attrs: {
                            column: column,
                            "sort-by": _vm.sortBy,
                            "sort-dir": _vm.sortDir,
                            "can-sort": _vm.isColumnSortable(column),
                            filter: _vm.getColumnFilter(column),
                          },
                          on: {
                            filter: _vm.configureFilter,
                            sort: _vm.emitSort,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _c("th", { attrs: { width: "70" } }),
                ],
                2
              ),
            ]),
            _c(
              "tbody",
              _vm._l(_vm.entries, function (entry) {
                return _c(
                  "tr",
                  { key: entry.id },
                  [
                    _vm._l(_vm.columns, function (column) {
                      return _c(
                        "td",
                        {
                          key: column.id,
                          attrs: {
                            align: column.type === "number" ? "right" : null,
                          },
                        },
                        [
                          _c("TableCell", {
                            attrs: {
                              entry: entry,
                              column: column,
                              lists: _vm.lists,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    _c(
                      "td",
                      [
                        _c("TableActions", {
                          attrs: { entry: entry, "can-edit": _vm.canEdit },
                          on: { edit: _vm.emitEdit, remove: _vm.emitRemove },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                )
              }),
              0
            ),
          ]),
        ]
      ),
      _c(
        "HorizontalTable",
        { staticClass: "sm", on: { nextPage: _vm.nextPage } },
        [
          _c("table", { staticClass: "h-table" }, [
            _c(
              "tbody",
              [
                _vm._l(_vm.columns, function (column) {
                  return _c(
                    "tr",
                    { key: column.id },
                    [
                      _c(
                        "th",
                        [
                          _c("TableHeader", {
                            attrs: {
                              column: column,
                              "sort-by": _vm.sortBy,
                              "sort-dir": _vm.sortDir,
                              "can-sort": _vm.isColumnSortable(column),
                              filter: _vm.getColumnFilter(column),
                            },
                            on: {
                              filter: _vm.configureFilter,
                              sort: _vm.emitSort,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._l(_vm.entries, function (entry) {
                        return _c(
                          "td",
                          { key: entry.id },
                          [
                            _c("TableCell", {
                              attrs: {
                                entry: entry,
                                column: column,
                                lists: _vm.lists,
                              },
                            }),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                }),
                _c(
                  "tr",
                  [
                    _c("th"),
                    _vm._l(_vm.entries, function (entry) {
                      return _c(
                        "td",
                        { key: entry.id },
                        [
                          _c("TableActions", {
                            attrs: { entry: entry, "can-edit": _vm.canEdit },
                            on: { edit: _vm.emitEdit, remove: _vm.emitRemove },
                          }),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
              ],
              2
            ),
          ]),
        ]
      ),
      _c("ColumnFilterModal", {
        ref: "columnFilterModal",
        on: {
          apply: function ($event) {
            return _vm.$emit("filter", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }